import { Outlet } from 'react-router';

export default () => <Outlet />;
